import { isTranslation } from "constants/internal"

import main from "./main"
import mainDynamic from "./dynamic-main"

export default {
    main: isTranslation ? mainDynamic : main,
}
